import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";

import { Row, Col, Alert, Container } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter, Link } from "react-router-dom";

// actions
import { loginUser, clearLoginError } from "../../store/actions";

const LOGIN_ROLE = "other-users";

const Login = (props) => {
  const [show, setshow] = useState(false);
  const [step, setStep] = useState(1);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [otp, setOtp] = useState("");
  const [otpChannel, setOtpChannel] = useState("sms"); // "sms" (default) | "email"
  const [canResend, setCanResend] = useState(false);
  const [resendCountdown, setResendCountdown] = useState(30);

  const dispatch = useDispatch();
  const history = props.history;

  const { error, loading, loginResponse } = useSelector((state) => ({
    error: state.Login?.error,
    loading: state.Login?.loading,
    loginResponse: state.Login?.loginResponse,
  }));

  useEffect(() => {
    const accessToken = window.localStorage.getItem("accessToken");
    if (accessToken) {
      props.history.push("/dashboard");
    }
  }, [loading]);

  useEffect(() => {
    if (loginResponse) {
      if (loginResponse.status === 200 && loginResponse.accessToken) {
        history.push("/dashboard");
        return;
      }

      if (loginResponse.requiresOtp || loginResponse.status === 200) {
        setStep(3);
        return;
      }

      if (loginResponse.status === 300 && loginResponse.roles) {
        setAvailableRoles(loginResponse.roles);
        setStep(2);
        return;
      }
    }
  }, [loginResponse, history]);

  useEffect(() => {
    if (step !== 3) {
      setResendCountdown(30);
      setCanResend(false);
      return;
    }

    if (resendCountdown <= 0) {
      setCanResend(true);
      return;
    }

    const timer = setInterval(() => {
      setResendCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [step, resendCountdown]);

  window.localStorage.setItem("login_role", LOGIN_ROLE);

  const goBack = () => {
    setOtp("");
    setSelectedRole("");
    setAvailableRoles([]);
    setOtpChannel("sms");
    setStep(1);
    dispatch(clearLoginError());
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(clearLoginError());

    if (!email || !password) {
      return;
    }

    let payload = {
      email: email.toLowerCase().trim(),
      password: password.trim(),
      otpChannel,
    };

    // Add role if in step 2 or 3
    if (step === 2) {
      if (!selectedRole) {
        return;
      }
      payload.role = selectedRole;
    }

    // Add OTP if in step 3
    if (step === 3) {
      if (!otp || otp.length !== 6) {
        return;
      }
      payload.otp = otp;
      if (selectedRole) {
        payload.role = selectedRole;
      }
    }

    console.log("🚀 [Component] Dispatching login with payload:", payload);
    dispatch(loginUser(payload));
  };

  // (Re)send the OTP through a chosen channel. Resending via the SAME channel is
  // rate-limited by the countdown; switching channel is always allowed.
  const sendOtpVia = (channel) => {
    setOtpChannel(channel);
    setResendCountdown(30);
    setCanResend(false);
    dispatch(clearLoginError());
    const payload = {
      email: email.toLowerCase().trim(),
      password: password.trim(),
      otpChannel: channel,
    };
    if (selectedRole) {
      payload.role = selectedRole;
    }
    dispatch(loginUser(payload));
  };

  const buttonText =
    step === 1 ? "Log In" : step === 2 ? "Continue" : "Verify OTP";

  // Get message from loginResponse
  const infoMessage = loginResponse?.message || "";

  return (
    <React.Fragment>
      <MetaTags>
        <title>Rentdigicare | Login</title>
      </MetaTags>
      <div className="auth-page">
        <Container fluid className="p-0">
          <Row className="g-0">
            <div
              className="col-xxl-8 col-lg-7 col-md-7 d-none d-sm-block"
              style={{
                backgroundImage: "url('images/Group 110@2x.png')",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                objectFit: "cover",
              }}
            >
              <img
                src="images/Layer 0@2x.png"
                alt="Company Logo"
                className="position-absolute top-0 start-0 m-4"
                style={{ maxWidth: "163px" }}
              />

              <div className="auth-full-page-content d-flex pb-5">
                <div className="w-100">
                  <div className="d-flex flex-column justify-content-center align-items-center h-100">
                    <div className="d-flex justify-content-start align-items-center w-75">
                      <p
                        className="h1 fs-1 fs-md-1 text-primary"
                        style={{
                          fontSize: "clamp(20px, 5vw, 50px)",
                          color: "#0c518a",
                        }}
                      >
                        <span style={{ fontWeight: "100" }}> Welcome to </span>
                        <br /> RentDigiCare
                      </p>
                      <div className="d-flex d-none d-lg-block">
                        <img
                          src="images/Group 108@2x.png"
                          alt=""
                          style={{ maxWidth: "115px" }}
                        />
                        <img
                          src="images/Group 109@2x.png"
                          alt=""
                          style={{ maxWidth: "100px" }}
                        />
                      </div>
                    </div>

                    <div
                      className="d-flex justify-content-start align-items-center w-75"
                      style={{
                        textAlign: "start",
                        lineHeight: "normal",
                        display: "flex",
                        justifyContent: "center",
                        margin: "25px 0 0",
                      }}
                    >
                      <span
                        className="fst-brd"
                        style={{
                          height: "6px",
                          borderRadius: "50px",
                          backgroundColor: "#ff6128",
                          display: "inline-block",
                          margin: "0 5px",
                          width: "16px",
                        }}
                      ></span>
                      <span
                        className="secend-brd"
                        style={{
                          height: "6px",
                          borderRadius: "50px",
                          backgroundColor: "#ff6128",
                          display: "inline-block",
                          margin: "0 5px",
                          width: "46px",
                        }}
                      ></span>
                      <span
                        className="fst-brd"
                        style={{
                          height: "6px",
                          borderRadius: "50px",
                          backgroundColor: "#ff6128",
                          display: "inline-block",
                          margin: "0 5px",
                          width: "16px",
                        }}
                      ></span>
                      <span
                        className="secend-brd"
                        style={{
                          height: "6px",
                          borderRadius: "50px",
                          backgroundColor: "#ff6128",
                          display: "inline-block",
                          margin: "0 5px",
                          width: "46px",
                        }}
                      ></span>
                    </div>

                    <div className="d-flex justify-content-start align-items-center w-75">
                      <p className="h3 mt-4">
                        <span style={{ fontWeight: "100", color: "#212121" }}>
                          Where Property Managers Feel Right at <br /> Home in
                          the World of{" "}
                          <span
                            style={{ fontWeight: "bold", color: "#0c518a" }}
                          >
                            Rental Success!
                          </span>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Col
              lg={5}
              md={5}
              className="col-xxl-4"
              style={{
                backgroundImage: "url('images/login page@2x.png')",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                objectFit: "cover",
              }}
            >
              <div className="auth-full-page-content d-flex p-sm-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="auth-content my-auto">
                      <div className="text-center">
                        <h2 className="mb-0" style={{ color: "#0c518a" }}>
                          Sign in here!
                        </h2>
                        <p className="text-muted mt-2">
                          Sign in to continue to Rentdigicare
                        </p>
                      </div>

                      <div
                        style={{
                          textAlign: "center",
                          lineHeight: "normal",
                          display: "flex",
                          justifyContent: "center",
                          margin: "25px 0 0",
                        }}
                      >
                        <span
                          className="fst-brd"
                          style={{
                            height: "6px",
                            borderRadius: "50px",
                            backgroundColor: "#ff6128",
                            display: "inline-block",
                            margin: "0 5px",
                            width: "16px",
                          }}
                        ></span>
                        <span
                          className="secend-brd"
                          style={{
                            height: "6px",
                            borderRadius: "50px",
                            backgroundColor: "#ff6128",
                            display: "inline-block",
                            margin: "0 5px",
                            width: "46px",
                          }}
                        ></span>
                      </div>

                      {error && (
                        <Alert color="danger" className="mt-4">
                          {error}
                        </Alert>
                      )}
                      {infoMessage && (
                        <Alert color="info" className="mt-4">
                          {infoMessage}
                        </Alert>
                      )}

                      <form
                        className="custom-form mt-2 pt-2"
                        onSubmit={handleSubmit}
                      >
                        {step === 1 && (
                          <>
                            {/* Email Field */}
                            <div className="mb-4">
                              <input
                                type="email"
                                className="form-control"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                              />
                            </div>

                            {/* Password Field */}
                            <div className="mb-4">
                              <div className="authPassInputgroup">
                                <input
                                  type={show ? "text" : "password"}
                                  className="form-control"
                                  placeholder="Password"
                                  value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                  required
                                />
                                {show ? (
                                  <button
                                    className="btn btn-light shadow-none ms-0"
                                    type="button"
                                    onClick={() => setshow(!show)}
                                  >
                                    <i className="bx bx-show"></i>
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-light shadow-none ms-0"
                                    type="button"
                                    onClick={() => setshow(!show)}
                                  >
                                    <i className="bx bxs-low-vision"></i>
                                  </button>
                                )}
                              </div>
                            </div>

                            {/* Remember me and Forgot Password */}
                            <div className="row mb-4">
                              <div className="col d-flex justify-content-between align-items-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="remember-check"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="remember-check"
                                  >
                                    Remember me
                                  </label>
                                </div>

                                <div className="flex-shrink-0">
                                  <div>
                                    <Link
                                      to="/forgot-password"
                                      className="text-muted"
                                    >
                                      Forgot password?
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        {step === 2 && (
                          <>
                            <div className="mb-3 text-center">
                              <p className="mb-0">
                                Multiple accounts found for{" "}
                                <strong>{email}</strong>.
                              </p>
                              <p className="mb-0">
                                Please select the role you want to log in with:
                              </p>
                            </div>
                            <div className="mb-4">
                              <label className="form-label">Select Role</label>
                              <select
                                className="form-control"
                                value={selectedRole}
                                onChange={(e) =>
                                  setSelectedRole(e.target.value)
                                }
                                required
                              >
                                <option value="">Choose a role</option>
                                {availableRoles.map((role) => (
                                  <option key={role} value={role}>
                                    {role.charAt(0).toUpperCase() +
                                      role
                                        .slice(1)
                                        .replace(/([A-Z])/g, " $1")}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <button
                              type="button"
                              className="btn btn-secondary w-100 mb-3"
                              onClick={goBack}
                            >
                              Back to Login
                            </button>
                          </>
                        )}

                        {step === 3 && (
                          <>
                            <div className="mb-3 text-center">
                              <p className="mb-0">
                                {loginResponse?.otpChannel === "sms"
                                  ? "Please enter the OTP sent to your phone:"
                                  : "Please enter the OTP sent to your email:"}
                              </p>
                            </div>

                            <div className="mb-4">
                              <input
                                type="text"
                                className="form-control text-center"
                                placeholder="Enter 6-digit OTP"
                                value={otp}
                                onChange={(e) =>
                                  setOtp(e.target.value.replace(/[^0-9]/g, "").slice(0, 6))
                                }
                                maxLength={6}
                                required
                              />
                            </div>

                            <button
                              type="button"
                              className="btn btn-secondary w-100 mb-3"
                              onClick={goBack}
                            >
                              Back to Login
                            </button>

                            {/* Resend OTP + channel switch */}
                            <div className="mb-4 text-center">
                              {canResend ? (
                                <button
                                  type="button"
                                  className="btn btn-link text-primary p-0"
                                  onClick={() => sendOtpVia(otpChannel)}
                                >
                                  Resend OTP
                                </button>
                              ) : (
                                <p className="text-muted mb-0 small">
                                  Resend OTP in {resendCountdown < 10 ? "0" : ""}
                                  {resendCountdown}s
                                </p>
                              )}

                              {/* Always-available channel switch */}
                              <div className="mt-2 small">
                                {otpChannel === "sms" ? (
                                  <button
                                    type="button"
                                    className="btn btn-link text-muted p-0"
                                    onClick={() => sendOtpVia("email")}
                                  >
                                    <i className="bx bx-envelope me-1"></i>
                                    Send code via Email instead
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    className="btn btn-link text-muted p-0"
                                    onClick={() => sendOtpVia("sms")}
                                  >
                                    <i className="bx bx-message-detail me-1"></i>
                                    Send code via SMS instead
                                  </button>
                                )}
                              </div>
                            </div>
                          </>
                        )}

                        {/* Login Button  */}
                        <div className="mb-3">
                          <button
                            className="btn btn-primary w-100 waves-effect waves-light"
                            type="submit"
                            disabled={loading}
                          >
                            {loading ? "Processing..." : buttonText}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Login.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Login);